import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface ILogoutResult extends IResult {
  redirectUrl: string;
}

export class LogoutRequest extends Request<{}, ILogoutResult> {
  constructor() {
    super('logout', {});
  }
}
